import React from 'react';
import { Container, Row, Col, Table } from 'react-bootstrap';
import { jobListings } from '../../fixtures';
import Link from 'next/link';
import css from 'styled-jsx/css';

const { className: pageContentContainerClassName, styles: pageContentContainerStyleOverrides } = css.resolve`
  .container.page_content_container {
    background-color: white;
    position: relative;
    bottom: 50px;
    padding-top: 100px;
    padding: 100px 60px 80px 60px;
  }
  @media (max-width: 576px) {
    .container.page_content_container {
      background-color: white;
      position: relative;
      bottom: 0px;
      padding-top: 100px;
      padding: 20px 20px 20px 20px;
    }
  }
`;

const SkeletonScreen = ({noJobsFound}) => {
  return (
    <div className="page about">
      <div className="section hero darken">
        <Container fluid>
          <Row>
            <Col style={{ paddingLeft: 0, paddingRight: 0 }}>
              <div className="hero_content_wrapper">
                <div className="hero_content">
                  <div className="intro"></div>
                  <div className="headline"></div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <div className="section page_content">
        <Container className={`${pageContentContainerClassName} page_content_container`}>
          <Row>
            <Col style={{ paddingLeft: 0, paddingRight: 0 }}>
              <div className="content_column">
                <div className="content_section">
                  {noJobsFound ? <>
                    <h4 className="section_header">Job opening is no longer available.</h4>
                <p className="section_text">
                Sorry, the opening you are looking for is not available. Please check back later for any updates on career opportunities with our company. In the meantime, you can explore our website to learn more about our organization and stay connected with us on social media for the latest news and updates.
                    </p> 
                  </> : null}
              
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {pageContentContainerStyleOverrides}
      <style jsx>{`


          .hero {
            background: ${noJobsFound ? 'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(/img/Career.jpg)' : '#4a4a4a'} ;
            /* background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), */
            background-position: center 0%;
            background-repeat: no-repeat;
            background-size: cover;
            text-align: center;
            color: white;
            font-family: 'Open Sans';
            animation: pulse 1s infinite ease-in-out;
          }

          @keyframes pulse {
            0% {
              background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.2)),
            }
            50% {
              background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
            }
            100% {
              background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.2)),
            }
          }
          .hero_content_wrapper {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 451px;
          }
          @media (max-width: 576px) {
            .hero {
              background-size: cover;
              background-position: center center;
            }
            .hero_content_wrapper {
              height: 311px;
            }
          }
          .hero_content {
            width: 30%;
          }
          @media (max-width: 991px) {
            .hero_content {
              width: 65%;
            }
          }
          @media (max-width: 576px) {
            .hero_content {
              width: 90%;
             margin-top: 60px;
            }
          }
          .hero .intro {
            color: #ffffff;
            font-size: 16px;
            font-weight: 600;
            line-height: 10px;
            text-align: center;
            text-transform: uppercase;
            margin-bottom: 20px;
          }
          .hero .headline {
            font-size: 34px;
            font-weight: bold;
            line-height: 46px;
            text-align: center;
          }
          @media (max-width: 991px) {
            .hero .headline {
              font-size: 24px;
              line-height: 33px;
            }
            .hero .intro {
              font-size: 15px;
              line-height: 10px;
              margin-bottom: 15px;
            }
          }
          .page_content {
            background-color: white;
          }
          .page_content .content_column {
            width: 70%;
            margin-left: auto;
            margin-right: auto;
          }
          @media (max-width: 576px) {
            .page_content .content_column {
              width: 90%;
            }
          }
          .page_content .content_section {
            margin-bottom: 40px;
          }
          .page_content .section_header {
            color: #3a3a3a;
            font-size: 22px;
            font-weight: 600;
            line-height: 35px;
          }
          .page_content .section_text {
            color: #3a3a3a;
            font-size: 16px;
            font-weight: 300;
            letter-spacing: 0.67px;
            line-height: 28px;
          }
          @media (max-width: 576px) {
            .page_content .section_text {
              font-size: 17.5px;
            }
          }
          .right-align {
            text-align: right;
          }
          tr td {
            padding: 1.05rem 0;
            color: #3a3a3a;
            font-size: 16px;
            font-weight: 300;
            letter-spacing: 0.67px;
            line-height: 28px;
          }
          tr:first-child td {
            border-width: 0;
          }
        `}</style>
    </div>
  )
}

export default SkeletonScreen